import axios from 'axios'
import router from '../router';
import { Message } from 'element-ui'
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../utils/contant/contant'
import { encryptBase64, encryptWithAes, generateAesKey, decryptWithAes, decryptBase64 } from '@/utils/crypto';
import { encrypt, decrypt } from '@/utils/jsencrypt';


const encryptHeader = 'encrypt-key';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 30
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	let accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
	let refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	if (refreshToken) {
		config.headers.refreshToken = encodeURIComponent(refreshToken);
	}
	if (process.env.VUE_APP_ENCRYPT === 'true') {
		// 检查是否为上传请求（FormData类型）
		const isUploadRequest = config.data instanceof FormData;
		// 检查是否为 webrtc 相关请求
		const isWebrtcRequest = config.url.includes('/webrtc');
		// 当开启参数加密
		if (!isUploadRequest && !isWebrtcRequest && (config.method === 'post' || config.method === 'put' || config.method === 'POST' || config.method === 'PUT')) {
			// 生成一个 AES 密钥
			const aesKey = generateAesKey();
			config.headers[encryptHeader] = encrypt(encryptBase64(aesKey));
			config.data = typeof config.data === 'object' ? encryptWithAes(JSON.stringify(config.data), aesKey) : encryptWithAes(config.data, aesKey);
		}
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (process.env.VUE_APP_ENCRYPT === 'true') {
		// 加密后的 AES 秘钥
		const keyStr = response.headers[encryptHeader];
		// 加密
		if (keyStr != null && keyStr != '') {
			const data = response.data;
			// 请求体 AES 解密
			const base64Str = decrypt(keyStr);
			// base64 解码 得到请求头的 AES 秘钥
			const aesKey = decryptBase64(base64Str.toString());
			// aesKey 解码 data
			const decryptData = decryptWithAes(data, aesKey);
			// 将结果 (得到的是 JSON 字符串) 转为 JSON
			response.data = JSON.parse(decryptData);
		}
	}
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem(REFRESH_TOKEN_KEY);
		if (!refreshToken) {
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			exit();
		})
		// 保存token
		localStorage.setItem(ACCESS_TOKEN_KEY, data.accessToken);
		localStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken);
		// 重新发送刚才的请求
		return http(response.config)
	} else if (response.data.code == 10060) {
		return Promise.reject(response.data)
	} else {

		Message({
			message: response.data.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	switch (error.response.status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			exit();
			break
		case 405:
			Message({
				message: 'http请求方式有误',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: '服务器出了点小差，请稍后再试',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: '服务器不支持当前请求所需要的某个功能',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}

	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
